import { makeStyles } from "@mui/styles";

const northControlStyle = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
    },
    northButtonContainer: {
        position: "absolute",
        bottom: "1.5rem",
        right: "7.2rem",
        zIndex: 1000,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        borderRadius: "23px",
        [theme.breakpoints.down("sm")]: {
            right: "8.8rem",
            padding: "0.2rem",
        },
    },
    northButton: {
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: 'center',
        zIndex: 1500,
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.5)",
        },
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.1)", // ✅ Increase button size for mobile
        },
  
    },
    compassIcon: {
        fontSize: "35px",
        color: "#333",
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.2)", // ✅ Increase button size for mobile
        },
    },
    popoverContainer: {
        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
        marginBottom: "16px !important",
        backgroundColor: "transparent",
        overflow: "hidden",
        borderRadius: "20px",
    },
    popoverContent: {
        position: 'relative',
        backgroundColor:  "#f5f5f5",
        padding: "45px 30px 40px 30px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "270px",
        borderRadius: "20px",
        marginBottom: "12px",
        marginRight: "12px",
    },
    popoverText: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#333",
    },
    closeButton: {
        position: "absolute !important",
        top: "10px",
        right: "10px",
        color: "#333",
        padding: "0px",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            borderRadius: "50%",
        },
    },
    label: {
        fontSize: "14px",
        fontWeight: "bold",
        marginBottom: "8px",
        color: "#333",
        alignSelf: "flex-start",
        minWidth: "70px",
    },
    sliderRow: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: "12px",
        paddingRight: '10px',
        paddingTop: '10px',

    },
    slider: {
        flexGrow: 1,
        marginBottom: "12px",
        "& .MuiSlider-track": {
            backgroundColor: "#1976d2",
        },
        "& .MuiSlider-rail": {
            backgroundColor: "#ccc",
            opacity: 1,
        },
        "& .MuiSlider-thumb": {
            backgroundColor: "#1976d2",
        },
    },
    resetButton: {
        fontSize: "14px",
        color: "#1976d2",
        cursor: "pointer",
        fontWeight: "bold",
        paddingTop: '15px',
        "&:hover": {
            textDecoration: "underline",
        },
    },
}));

export default northControlStyle;